import React from "react";
import { useRacketLabAdminT } from "../../i18n/racketLabAdminI18n";
import { ENVELOPE_STATUS_LABEL_KEY, labelKeyFor } from "../../i18n/racketLabMaps";

const STYLES = {
  draft: "bg-slate-100 text-slate-700",
  queued: "bg-sky-100 text-sky-800",
  dispatched: "bg-emerald-100 text-emerald-800",
  cancelled: "bg-rose-100 text-rose-800",
  failed: "bg-amber-100 text-amber-800",
};

/**
 * EnvelopeStateBadge — visual chip for notification envelope statuses.
 *
 * QUICK 1.B i18n migration: visible label resolved via
 * `ENVELOPE_STATUS_LABEL_KEY` map. The `status` payload value stays
 * untouched for `data-testid` and style lookup.
 */
export const EnvelopeStateBadge = ({ status, dataTestId }) => {
  const t = useRacketLabAdminT();
  const cls = STYLES[status] || "bg-slate-100 text-slate-700";
  return (
    <span data-testid={dataTestId || `rl-envelope-state-${status || "unknown"}`}
      className={`inline-flex rounded-full px-2 py-0.5 text-[10px] font-medium ${cls}`}>
      {status ? t(labelKeyFor(ENVELOPE_STATUS_LABEL_KEY, status)) : "—"}
    </span>
  );
};
export default EnvelopeStateBadge;
